<template>
    <div></div>
</template>

<script>
import formMixin from "@tenant/app-form/mixins/formMixin"
import { mapGetters } from "vuex"

export default {
    name: "FormStore",

    mixins: [formMixin],

    props: {
        formProp: {
            required: true,
            type: Object,
        },
        coreProp: {
            required: true,
            type: Object,
        },
        getExistingSignature: {
            type: String,
        },
        saveReusableSignature: {
            type: String,
        },
        formStore: {
            required: false,
            type: String,
            default: "formStore",
        },
    },

    data() {
        return {}
    },

    async created() {
        this.$store.dispatch(`${this.formStore}/form/setFieldComponents`, await this.getFieldComponents())
        this.$store.dispatch(`${this.formStore}/core/set`, this.coreProp)
        this.$store.dispatch(`${this.formStore}/form/set`, this.formProp)
        this.$store.dispatch(`${this.formStore}/form/setReusableSignature`, this.saveReusableSignature)
        this.$store.dispatch(`${this.formStore}/form/setExistingSignature`, this.getExistingSignature)
    },

    computed: {
        ...mapGetters({
            application: "appStore/application/get",
        }),
        formFieldBlacklist() {
            return this.$store.getters[`${this.formStore}/form/formFieldBlacklist`]
        },
        formFields() {
            return this.$store.getters[`${this.formStore}/form/formFields`]
        },
        searchObjects() {
            return this.$store.getters[`${this.formStore}/core/searchObjects`]
        },
    },

    mounted() {},

    methods: {
        async getFieldComponents() {
            let formFields = require.context("../fields", true, /\.vue$/)
            let fields = await formFields.keys().reduce((field, fieldPath) => {
                const moduleName = fieldPath.replace(/^\.\/(.*)\.\w+$/, "$1")
                field[moduleName] = formFields(fieldPath).default
                return field
            }, {})
            return fields
        },
    },

    watch: {
        formFields: {
            handler(fields) {
                this.setFormFields(fields)
            },
            deep: true,
            immediate: false,
        },
        formData: {
            handler(formData) {
                if (this.isFrontend && this.form.form_type === "custom-fields") {
                    let customField = this.application.form_custom_fields.find(
                        (customField) => customField.form_id === this.form.id
                    )
                    customField.form_custom_field_entry.fields = formData
                }
            },
            deep: true,
        },
    },
}
</script>

<style lang="scss" scoped></style>
